import { BookingComp } from './BookingComp';

export default BookingComp;
